const deprecatedPropsToProps = (props) => {
  const { schedule, highlightCurrentDay, ...rest } = props;
  const openingHours = Object.entries(schedule).reduce(
    (acc, [key, value]) => {
      const day = Object.keys(acc).find(
        (dayName) => key.includes(dayName.slice(0, 3)) && key.includes("OpenClose")
      );
      if (day && value) {
        acc[day] = value.map(({ open, close }) => {
          const openChars = [...String(open)];
          const closeChars = [...String(close)];
          if (!openChars.includes(":") && !openChars.includes(".")) {
            openChars.splice(-2, 0, ":");
          }
          if (!closeChars.includes(":") && !closeChars.includes(".")) {
            closeChars.splice(-2, 0, ":");
          }
          return {
            open: openChars.join(""),
            close: closeChars.join("")
          };
        });
      }
      return acc;
    },
    {
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      sunday: []
    }
  );
  return { openingHours, ...rest };
};
export {
  deprecatedPropsToProps
};
//# sourceMappingURL=utils.js.map
